import axios from 'axios'
export const httpPostRequest = function(params) { // 实际使用的 请求方法
    params = params || {} //传递的参数先赋值给params
    params.method = params.method || 'post'; //如果参数没有指定方法那就设置为post
    if (params.method == 'post') { //如果请求方式为post
        if(params.route === 1){
            let url = "https://zjnb.720pai.cn/api";
            params.url = `${url+params.url}`;
        }else{
            let url = "https://zjnb.720pai.cn/api2";
            params.url = `${url+params.url}`;
        }
        
        let formData = new FormData(); //创建一个fomData对象 存储参数
        for (var item in params.data) { //判断本事是否有此属性，有的话就加入formData对象中
            if (params.data.hasOwnProperty(item)) { //是否包含itemID
                formData.append(item, params.data[item]);
            }
        }
        // params.headers = {
        //     'Content-Type': 'application/x-www-form-urlencoded'
        // }
        params.data = formData;
    }
    return new Promise((resolve, reject) => {
        axios(params)
        .then(res => {
                resolve(res.data)
            
        })
        .catch((err) => {
            // alert('网络繁忙，请稍后再试！')
        })
    })
}